const getUserEmail = state => state.view.email || '';

export default getUserEmail;
